import store from '@/store'
import { auth } from '@/auth/hyper-auth'
import { getUserInfo, getAuthPrerequisites } from './common'
const getProfileUserInfo = () => store.getters.userInfo

const refreshProfileUserInfo = async () => {
    const userIdx = getUserInfo().userIdx
    try {
        await store.dispatch('getProfileUserInfo', { userIdx })
        return getProfileUserInfo()
    } catch (error) {
        throw error
    }
}

const getRoutePrerequisites = () => {
    const prerequisites = getAuthPrerequisites()
    if (prerequisites.length) {
        if (prerequisites.indexOf('tc') > -1) {
            return { name: 'agreement' }
        } else if (prerequisites.indexOf('password') > -1) {
            return { name: 'password' }
        } else if (prerequisites.indexOf('otp') > -1) {
            return { name: 'otp' }
        }
    }
    return { name: 'home' }
}

const getRouteForUserFromService = async (params) => {
    const { email, token } = params
    const from = params.from
    localStorage.setItem(auth.authConfig.storageTokenKeyName, token)
    try {
        await store.dispatch('createMemberAuthAgain', { email })
        if (from) {
            store.commit('SAVE_AUTH_FROM', from)
        }
        return getRoutePrerequisites()
    } catch (error) {
        return { name: 'auth-login' }
    }
}

export {
    getProfileUserInfo,
    refreshProfileUserInfo,
    getRoutePrerequisites,
    getRouteForUserFromService
}
